<template>
  <el-input
    class="custom-car-number"
    v-model="carNumber"
    clearable
    autocomplete="off"
    maxlength="7"
    @change="handleUpdate"
    placeholder="请输入"
  >
    <!-- 下拉框增加 @change 监听 -->
    <el-select
      v-model="carZh"
      slot="prepend"
      filterable
      placeholder="请选择"
      @change="handleUpdate"
    >
      <el-option
        :label="item"
        :value="item"
        v-for="item in defaultData"
        :key="item"
      ></el-option>
    </el-select>
  </el-input>
</template>

<script>
export default {
  name: "Custom-Car-Number",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      carNumber: "",
      carZh: "京",
      defaultData: [
        "京", "津", "沪", "渝", "冀", "豫", "云", "辽", "黑", "湘",
        "皖", "鲁", "新", "苏", "浙", "赣", "鄂", "桂", "甘", "晋",
        "蒙", "陕", "吉", "闽", "贵", "粤", "青", "藏", "川", "宁",
        "琼", "使", "领"
      ],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.setCarNumber(newVal);
      },
    },
  },
  methods: {
    // 解析完整车牌，拆分 省份 + 号码
    setCarNumber(val) {
      if (!val) {
        this.carNumber = "";
        this.carZh = "京";
        return;
      }
      this.carZh = val.charAt(0);
      this.carNumber = val.substring(1);
    },
    // 统一更新方法：拼接并向外派发事件
    handleUpdate() {
      const fullPlate = this.carZh + this.carNumber;
      this.$emit("input", fullPlate);
    }
  },
};
</script>

<style lang="scss">
::v-deep .el-input-group__prepend {
  min-width: 1rem;
}
</style>
